module.exports = __webpack_public_path__ + "static/media/medalha_1.5c0d803d.svg";